import { History, Loader2 } from "lucide-react";

import { Button } from "@/components/ui";

type Props = {
  busy: boolean;
  onClick: () => void;
};

export function PastAnswersButton({ busy, onClick }: Props) {
  return (
    <Button
      type="button"
      variant="outline"
      onClick={onClick}
      disabled={busy}
      title="Fill open rows from this store's past answers. No AI call."
      className="shrink-0"
    >
      {busy ? (
        <Loader2 className="h-4 w-4 animate-spin" />
      ) : (
        <History className="h-4 w-4" />
      )}
      {busy ? "Using past answers..." : "Use past answers"}
    </Button>
  );
}
